import * as React from 'react';

const MapPinSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="map-pin_svg__eds-icon--map-pin_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <path
            id="map-pin_svg__eds-icon--map-pin_base"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 3c3.3 0 6 2.7 6 6 0 1.5-.6 3.1-1.8 4.9-.7 1.1-2.9 4.4-4.2 6.3-1.2-1.8-3.5-5.2-4.2-6.2C6.6 12.1 6 10.4 6 9c0-3.3 2.7-6 6-6m0-1C8.1 2 5 5.1 5 9c0 2 1 4 2 5.5l5 7.5 5-7.5C18 13 19 11 19 9c0-3.9-3.1-7-7-7"
        />
        <path
            id="map-pin_svg__eds-icon--map-pin_circle"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 6c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3zm0 5c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
        />
    </svg>
);

MapPinSvg.displayName = 'MapPinSvg';
export default MapPinSvg;
